import type { InteractorContent } from '../../src/viewers/components/types';

import { SyncExternalStore } from '@egr/xbox/utils/SyncExternalStore';

import { ListenableEvent } from '@easterngraphics/wcf/modules/utils/ListenableEvent';
class InteractorSelectionStore extends SyncExternalStore<{
    selectedArticle: InteractorContent | null;
    dialogOpen: boolean;
}> {
    constructor() {
        super({
            selectedArticle: null,
            dialogOpen: false,
        });
    }

    public getSelectedArticle(): InteractorContent | null {
        return this.snapshot.selectedArticle;
    }

    public setSelection(article: InteractorContent | null): void {
        this.updateState({
            selectedArticle: article,
            dialogOpen: true,
        });
        if (article != null) {
            this.onArticleChange.trigger({ articleData: article });
        }
    }

    public setDialogOpen(open: boolean): void {
        if (this.internalState.dialogOpen != open) {
            this.updateState({ dialogOpen: open });
        }
    }

    public resetStore(): void {
        this.updateState({
            selectedArticle: null,
            dialogOpen: false,
        });
    }

    public readonly onArticleChange: ListenableEvent<{ articleData: InteractorContent }, undefined> = new ListenableEvent<
        { articleData: InteractorContent },
        undefined
    >(undefined);
}

export const interactorSelectionStore = new InteractorSelectionStore();
